<template>
  <div class="background-container">
    <div class="text-content">
      <Loading :loading="loading"></Loading>
      <div v-if="this.$route.query.sso && !studentInfoArea && !error" style="text-align: center;">
        <p style="font-size: 20px; font-weight: bold;">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</p>
        <p>&nbsp;</p>
        <p style="font-size: 20px; font-weight: bold;">Please wait, you are being redirected to the relevant platform.</p>
      </div>
      <div v-if="studentInfoArea && !error">
        <p style="font-weight: bold;">Değerli Öğrencimiz,</p>
        <p>Espresso'ya hoş geldiniz. Giriş talebiniz işleme alınmıştır ve hesabınız, en geç 24 saat içerisinde aktif hale gelecektir. Bu süre zarfında beklediğiniz için teşekkür ederiz.</p>
        <p>Size destek olabileceğimiz her türlü konuda, 0850 550 50 90 numaralı telefonumuzdan ya da diğer destek kanallarımızdan bize ulaşabilirsiniz.</p>
        <p>&nbsp;</p>
        <p style="font-weight: bold;">Dear Student,</p>
        <p>Welcome to Espresso. Your login request has been processed, and your account will be activated within 24 hours. We appreciate your patience during this time.</p>
        <p>If you need any assistance, please feel free to contact us at 0850 550 50 90 or through our other support channels</p>
      </div>
      <SsoError v-if="error" :message="error"></SsoError>
<!--      <div v-if="razPlusTeacher" style="width: 600px;">-->
<!--        <p style="font-weight: bold;">Dear {{ this.uesLmsUserData.user_name }},</p>-->
<!--        <p>&nbsp;</p>-->
<!--        <p><strong>Please select the class you wish to enter:</strong><br />(Please make sure your browser does not block pop-ups.)</p>-->
<!--        <p>&nbsp;</p>-->
<!--        <div v-for="(class_name, class_id, key) in uesLmsUserData.class_name" :key="key" style="display:inline-flex;">-->
<!--          <div style="background-color: #118019; margin: 6px; display: inline-block; font-weight: bold;">-->
<!--            <div @click="getRazToken(class_id, 'teacher')" style="padding: 10px 20px; color: #fff; cursor: pointer;">-->
<!--              {{ class_name }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "Espresso",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'NJjNop!B2LJbfgcswaiwdVheMG-hLnx3WD!ibTLVpPNqeCYn7-TiCtHjFDkR.BCy',
      userData: null,
      user_id: null,
      user_role: null,
      token: null,
      studentInfoArea: false,
      uesLmsUserData: [],
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    } else {
      location.href = "https://service.ueslms.com";
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('Espresso SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/espresso/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/espresso/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.uesLmsUserData = response.data.user
              if (response.data.user.minutes > 1080) {
                // this.loading = false;
                // console.log('USER DATA', this.uesLmsUserData)
                this.goEspresso()
              } else {
                this.loading = false;
                this.studentInfoArea = true;
              }
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/espresso/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/espresso/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              // Kayıt yeni oluşmuşsa beklemesi gerekiyor.
              this.loading = false;
              this.studentInfoArea = true;
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    goEspresso() {
      this.loading = true;
      
      // Kullanıcı ID'sini doğru şekilde al
      /*let userId = '';
      if (this.userData && this.userData.user_id) {
        userId = this.userData.user_id;
      } else if (this.uesLmsUserData && this.uesLmsUserData.user_id) {*/
      let userId = this.uesLmsUserData.user_id;
      /*} else {
        this.loading = false;
        alert('Kullanıcı ID bilgisi bulunamadı!');
        return;
      }*/
      
      const data = {
        userId: userId,
        clientId: 'espresso',
        iss: 'https://ueslms-service-api.ey.r.appspot.com',
        deploymentId: '112233',
        loginUrl: 'https://lti.discoveryeducation.com/oauth2/lti-signin',
        targetLinkUri: 'https://lti.discoveryeducation.com/oauth2/lti-signin',
        redirectUri: 'https://lti.discoveryeducation.com/oauth2/lti-authorized'
      };

      axios.post('https://ueslms-service-api.ey.r.appspot.com/lti/generateLtiLaunchUrl', data)
          .then((response) => {
            this.loading = false;

            if (response.data && response.data.launchUrl) {
              window.open(response.data.launchUrl, '_top');
            } else {
              alert('Hata: launchUrl alınamadı');
            }
          })
          .catch(error => {
            this.loading = false;
            
            if (error.response) {
              alert(`Form gönderimi başarısız! Hata kodu: ${error.response.status}`);
            } else if (error.request) {
              alert('Sunucudan yanıt alınamadı. Lütfen internet bağlantınızı kontrol edin.');
            } else {
              alert(`Form gönderimi başarısız! Hata: ${error.message}`);
            }
          });
    },

  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial, sans-serif;
}

.background-container {
  margin: 0 auto;
  position: relative;
  width: 1200px;
  min-height: 675px;
  background-image: url('/assets/images/bg-espresso.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: start;
}

.text-content {
  width: 700px;
  margin-top: 175px;
  text-align: left;
  color: white;
}

p {
  font-size: 16px;
  line-height: 26px;
}
</style>
